import { AnalyticsEvent, AnalyticsEventNameType } from "@coeff/api";
import { message as messageAD } from "antd";
import React from "react";

import { MessageContext } from "../globals/contexts";

const addTrackingToMessage = (
  message: typeof messageAD,
  track: (event: AnalyticsEventNameType, extraProperties?: AnalyticsEvent) => void
): typeof messageAD => {
  return {
    ...message,
    error: (...args) => {
      track(AnalyticsEventNameType.RedToastErrorShown, {
        error_message: args[0]?.toString?.(),
      });

      return message.error(...args);
    },
  };
};

type Props = {
  message: typeof messageAD;
  track: ((event: AnalyticsEventNameType, extraProperties?: AnalyticsEvent) => void) | undefined;
};

export const MessageProvider: React.FC<Props> = ({ message, track, children }) => {
  return (
    <MessageContext.Provider value={track ? addTrackingToMessage(message, track) : message}>
      {children}
    </MessageContext.Provider>
  );
};
